export default "__VITE_ASSET__By6nLfvZ__"